import PropTypes from 'prop-types';
import React from 'react';
import Button from 'react-bootstrap/lib/Button';
import classnames from "classnames";

import { translate as t } from '../../lib/I18n';

function SearchFooter ({ disabled, onSearch, type, hasFooterPoweredByOn }) {
    return (
        <footer
            className={ classnames(
                "booking__footer clearfix",
                {
                    "booking__footer--with-powered-by-on": hasFooterPoweredByOn
                })
            }
        >
            <Button bsStyle="primary"
                className="btn-lg pull-right"
                disabled={ disabled }
                onClick={ onSearch }>
                { t(`booking.search.${type}`) }
            </Button>
        </footer>
    );
}

SearchFooter.propTypes = {
    disabled: PropTypes.bool,
    onSearch: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    hasFooterPoweredByOn: PropTypes.bool,
};

SearchFooter.defaultProps = {
    disabled: false,
    hasFooterPoweredByOn: false,
};

export default SearchFooter;



// WEBPACK FOOTER //
// ./src/components/search/Footer.js